import { NSButton, NSCard } from 'bricks';
import React from 'react';
import '../Deals.scss';
import { generatePath, useNavigate } from 'react-router-dom';
import { URLS } from 'services/urls';
import { Col, Row } from 'reactstrap';

const EmptyState = () => {
    const navigate = useNavigate();
    return (
        <NSCard className="Deals__empty-state pl-3 mt-2">
            <Row className="h-100 mr-0">
                <Col md="6" className="d-flex align-items-center h-100" style={{ zIndex: 1 }}>
                    <div className="pl-4 d-flex flex-column">
                        <h1 className="Deals__empty-state__title text-white font-weight-bold mb-0">Create your first deal.</h1>
                        <h4>
                            Build your first deal from scratch or use existing documentation to
                            <br />
                            auto-create a deal.
                        </h4>
                        <div>
                            <NSButton
                                color="primary"
                                className="mr-2 px-4 heap-deal-pipeline-empty-create-deal"
                                callback={() => {
                                    navigate(generatePath(URLS.DEALS.FORM, { dealId: 'new' }));
                                }}
                            >
                                Create Deal
                            </NSButton>
                            <NSButton
                                className="NSButton--secondary-lighten px-4 heap-deal-pipeline-empty-bulk-upload"
                                callback={() => {
                                    navigate(URLS.DEALS.BULK_UPLOAD);
                                }}
                            >
                                Bulk upload deals
                            </NSButton>
                        </div>
                    </div>
                </Col>
                <Col md="6" className="d-flex justify-content-end pr-0" style={{ zIndex: 0 }}>
                    <img
                        src={URLS.IMAGE_CLOUDFRONT_URL('building_blocks.png')}
                        alt="Building blocks"
                        className="Deals__image"
                    />
                </Col>
            </Row>
        </NSCard>
    );
};

export default EmptyState;
